import React, { useState, useEffect, useCallback } from "react";
import { Menu } from "antd";
import { chain, get, findIndex } from "lodash";
import store from "store";
import routes from "@/config/routes";
import storeKey from "@/config/localstorage";
import history from "@/history";

interface MenuListProps {
     activityKey?: string;
     onChangeSelect?: () => void;
}
const routesList: any = routes[3].routes;

function getKey() {
     const url = window.location.pathname;
     const keys = chain(routesList).find((it: any) => url === it.path).value();
     let key = get(keys, "key", "");
     if (key === "") {
          const keys = chain(routesList).find((it: any) => it.path !== "/" && url.indexOf(it.path) > -1).value();
          key = get(keys, "key", "");
     }
     return key;
}

function MenuList(props: MenuListProps) {
     const { activityKey, onChangeSelect } = props;
     const [activeKey, setActiveKey] = useState("images");
     const {isAdmin, permissionList} = store.get(storeKey.userInfo);

     const MenuItem = useCallback(() => {
          return routesList.map((it: any) => {
               if (!isAdmin && it.name === '上传' && findIndex(permissionList, ['code', 'upload']) === -1) {
                    return;
               }
               if (it.isShow && it.auth <= isAdmin) {
                    return (
                         <Menu.Item key={it.key}>
                              {it.name}
                         </Menu.Item>
                    );
               }
               return null;
          });
     }, [isAdmin, permissionList]);

     useEffect(() => {
          const key = getKey();
          setActiveKey(key);
     }, [activityKey]);

     useEffect(() => {
          const onpopstate = () => {
               const key = getKey();
               setActiveKey(key);
          };
          window.addEventListener("popstate", onpopstate, true);
          return () => {
               window.removeEventListener("popstate", onpopstate);
          };
     });

     const onSelect = useCallback(({ key }) => {
          const paths = chain(routesList).find((it: any) => it.key === key).value();
          const path = get(paths, "path", "");
          history.push(path);
          setActiveKey(key);
          if (onChangeSelect) {
               onChangeSelect();
          }
     }, [onChangeSelect]);

     return (
          <Menu selectedKeys={[activeKey]} mode="horizontal" onClick={onSelect}>
               {MenuItem()}
          </Menu>
     );
}

export default MenuList;


